module.exports = __webpack_public_path__ + "img/logo-point-site.f6e30a8c.png";